module.exports = __webpack_public_path__ + "img/50.6d8b3ad2.jpg";